import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "44",
  height: "44"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "#000",
      "stroke-width": "1.5",
      transform: "translate(9 9)"
    }, [
      _createElementVNode("circle", {
        cx: "10.648",
        cy: "10.648",
        r: "10.648"
      }),
      _createElementVNode("path", {
        "stroke-linecap": "round",
        d: "m18.981 18.056 7.871 6.481"
      })
    ], -1)
  ]))]))
}
export default { render: render }